<template>
  <section class="section container pt-0">
    <organization-datatable />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import OrganizationDatatable from "./organization_datatable/Index.vue";
export default {
  name: "StaffOrganization",
  components: {
    OrganizationDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // let v = this;
      // get_configuration(this)
      //   .then((conf) => {
      //     v.module_settings = conf;
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {},
    refresh() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
